<div class="home-main-container">
	<div [ngClass.lt-lg]="'main-hero-image-height-lt-lg'"
	     class="main-hero-image mat-elevation-z2"
	     fxLayout="column"
	     fxLayoutAlign="center center">
		<div fxFlex="40" fxFlex.lt-lg="80" fxLayout="column"
		     fxLayoutAlign="center center">
			<div fxLayout="column" class="">
				<h1 class="center-text">
					<span style="font-size: xxx-large !important; padding: 5px" class="main-hero-content font-logo">CapChaos e.U.</span>
				</h1>
			</div>
			<button color="accent" (click)="expansionPanel1.open();scroll(accordion)" mat-raised-button>Explore
			</button>
		</div>
	</div>

	<mat-accordion class="main-accordion" #accordion>
		<mat-expansion-panel #expansionPanel1>
			<mat-expansion-panel-header>
				<mat-panel-title i18n="{Home | Panel Title One}">
					What is CapChaos doing?
				</mat-panel-title>
				<mat-icon style="padding-right: 10px">sentiment_satisfied_alt</mat-icon>
			</mat-expansion-panel-header>

			<div fxLayout="row" fxLayout.lt-lg="column"
			     fxLayoutAlign="start start" fxLayoutAlign.lt-lg="start center">
				<div fxFlex="50" fxFlex.lt-lg="100">
					<p class="align-justify">This is
						<a href="https://www.linkedin.com/in/franzgerhart/" target="_blank">me</a>
					                         and my network of professionals providing services to
					                         organizations in need of help with</p>
					<ul>
						<li><a routerLink="/services/business-intelligence">business intelligence</a>,</li>
						<li><a routerLink="/services/software-strategy">software strategy </a>and</li>
						<li><a routerLink="/services/tactical-management">tactical management</a>.</li>
					</ul>

					<p class="align-justify">I am fluent in bridging the gap between low-level tactical decision making
					                         and high-level strategic planning, ensuring that one doesn’t obliterate the
					                         other. As an iGaming veteran and enthusiast in enterprise-grade software
					                         development I very much enjoy challenging markets and industries.</p>
					<p class="align-justify">IT in particular is predicated upon ever-changing technology stacks that
					                         provide opportunity in every obstacle. I am passionate about finding such
					                         opportunities by crafting applications, designing architecture, and
					                         developing business logic.</p>
					<div style="text-align: center">
						<button color="primary" routerLink="/legal/contact" mat-raised-button>Contact</button>
					</div>

				</div>
				<div fxFlex="50" fxFlex.lt-lg="100" class="" fxLayoutAlign="center center">
					<img fxFlex.lt-lg="100" src="assets/images/kanban.webp" alt="">
				</div>
			</div>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title>
					How am I useful for you?
				</mat-panel-title>
				<mat-icon style="padding-right: 10px">task_alt</mat-icon>
			</mat-expansion-panel-header>
			<div fxLayout="row" fxLayout.lt-lg="column"
			     fxLayoutAlign="start start" fxLayoutAlign.lt-lg="start center">
				<div fxFlex="50" fxFlex.lt-lg="100" class="" fxLayoutAlign="center center">
					<img fxFlex.lt-lg="100" src="assets/images/how-to-help.webp" alt="">
				</div>
				<div fxFlex="50" fxFlex.lt-lg="100">
					<p class="align-justify">Looking at projects, there are four things that can and often will cause
					                         issues and subsequent delays.</p>
					<ul>
						<li>Change requests</li>
						<li>Communication</li>
						<li>Conflict</li>
						<li>Lack of knowledge in project management methodology</li>
					</ul>

					<p class="align-justify">You may rightly say there are more, however this to me is and always was
					                         the highest observable order problems may be deduced from. Change requests
					                         are inevitable and constant. One can do well in orchestrating teams around
					                         them, but they will keep coming.</p>
					<p class="align-justify">Good managers can do an outstanding job and become effective in handling
					                         conflict and communication. Excellent managers also use applied knowledge
					                         in management methodology which makes them efficient. </p>
					<p class="align-justify">I took me years to develop the skill and apply that knowledge, find the
					                         right tools & processes for the project, and understand how to scale
					                         them. </p>
					<p class="align-justify">Being effective gets the job done. Being efficient will get the job done
					                         repeatedly at high-quality and without fatigue. I will gladly assist your
					                         organisation in becoming more efficient. </p>
					<div style="text-align: center">
						<button color="primary" routerLink="/legal/contact" mat-raised-button>Contact</button>
					</div>
				</div>
			</div>
		</mat-expansion-panel>

		<mat-expansion-panel>
			<mat-expansion-panel-header>
				<mat-panel-title>
					What is it that I am not doing!
				</mat-panel-title>
				<mat-icon style="padding-right: 10px">block</mat-icon>
			</mat-expansion-panel-header>
			<div fxLayout="row" fxLayout.lt-lg="column"
			     fxLayoutAlign="start start" fxLayoutAlign.lt-lg="start center">
				<div fxFlex="50" fxFlex.lt-lg="100">
					<p class="align-justify">There are things I am sure capable of doing but you are definitely better
					                         off letting others take care of them. The IT industry isn’t far off the
					                         medical sector in this regard. You’d probably never asked a cardiologist to
					                         fix your teeth. Conversely, your database replication won't be fixed by a
					                         fronted engineer.</p>
					<p class="align-justify">This is not an exhaustive list, but you will recognize the
					                         pattern. </p>
					<ul>
						<li>Setting up your company website (WordPress etc.)</li>
						<li>Web design</li>
						<li>Graphics design</li>
						<li>Content / copy</li>
						<li>First- and second level employee IT support</li>
						<li>E-Mail server administration</li>
						<li>Backup and security solutions</li>
						<li>Legal matters</li>
					</ul>

					<p class="align-justify">If you need that kind of help though, do contact me as well, I know the
					                         right people and will be happy to introduce them.</p>

					<div style="text-align: center">
						<button color="primary" routerLink="/legal/contact" mat-raised-button>Contact</button>
					</div>
				</div>
				<div fxFlex="50" fxFlex.lt-lg="100" class="" fxLayoutAlign="center center">
					<img fxFlex.lt-lg="100" src="assets/images/no-service.webp" alt="">
				</div>
			</div>
		</mat-expansion-panel>

	</mat-accordion>

	<div fxLayout="column" fxFlex="100%" fxLayoutAlign="center" style="margin: 20px 10px 0 10px">
		<div fxFlex="70" fxFlex.lt-lg="100">
			<h1 class="center-text mat-card-title">Value propositions</h1>
			<p style="font-size: medium" class="center-text mat-card-content">The three core areas CapChaos will be valueable for your
			                                         organization.</p>
		</div>
	</div>

	<div fxLayout="row" fxLayout.lt-lg="column"
	     fxLayoutAlign="start">
		<div fxFlex="33" fxFlex.lt-lg="100" style="padding: 10px">
			<mat-card>
				<mat-card-header>
					<div mat-card-avatar class="bi-header-image"></div>
					<mat-card-title>Business Intelligence</mat-card-title>
					<mat-card-subtitle>The backbone of decision making</mat-card-subtitle>
				</mat-card-header>
				<img mat-card-image src="assets/images/business-intelligence.webp" alt="">
				<mat-card-content>
					<p>Data processing, generating papers, drawings, calculations, KPIs, processes and other data driven
					   knowledge
					   conducive to tactical management and decision making are a key element to any organization’s
					   growth and prosperity.</p>
				</mat-card-content>
				<mat-card-actions align="end">
					<button color="primary" routerLink="/legal/contact" mat-stroked-button>Contact</button>
					<button color="accent" routerLink="/services/business-intelligence" mat-raised-button>Read more
					</button>
				</mat-card-actions>
			</mat-card>
		</div>

		<div fxFlex="33" fxFlex.lt-lg="100" style="padding: 10px">
			<mat-card>
				<mat-card-header>
					<div mat-card-avatar class="strategy-header-image"></div>
					<mat-card-title>Software Strategy</mat-card-title>
					<mat-card-subtitle>Choosing the right tech stack</mat-card-subtitle>
				</mat-card-header>
				<img mat-card-image src="assets/images/software-strategy.webp" alt="">
				<mat-card-content>
					<p>Server-less cloud architecture or bare metal deployment? React or Angular? MySQL or PostgreSQL?
					   There are pros and cons on either side of the aisle but decisions can’t be taken lightly and are
					   often close to irreversible!</p>
				</mat-card-content>
				<mat-card-actions align="end">
					<button color="primary" routerLink="/legal/contact" mat-stroked-button>Contact</button>
					<button color="accent" routerLink="/services/software-strategy" mat-raised-button>Read more</button>
				</mat-card-actions>
			</mat-card>
		</div>


		<div fxFlex="33" fxFlex.lt-lg="100" style="padding: 10px">
			<mat-card>
				<mat-card-header>
					<div mat-card-avatar class="management-header-image"></div>
					<mat-card-title>Tactical Management</mat-card-title>
					<mat-card-subtitle>Beyond strategic planning</mat-card-subtitle>
				</mat-card-header>
				<img mat-card-image src="assets/images/tactical-management.webp" alt="">
				<mat-card-content>
					<p>Great strategy is powerful only when in the hands of dedicated people, capable of executing on
					   its subject matter, possessing the needed skills, using the right set of tools and
					   willing to pursue change in its most challenging format.</p>
				</mat-card-content>
				<mat-card-actions align="end">
					<button color="primary" routerLink="/legal/contact" mat-stroked-button>Contact</button>
					<button color="accent" routerLink="/services/tactical-management" mat-raised-button>Read more
					</button>
				</mat-card-actions>
			</mat-card>
		</div>
	</div>

	<app-footer></app-footer>

</div>

